import React from "react";
import { cx } from "@emotion/css";
import { FieldProps } from "formik";
import formGroupStyles from "../css/formgroup.module.css";
import { PfSwitchButton } from "./PfSwitchButton";

interface OtherProps {
  label: string;
  onClick: () => void;
  id: string;
}

type FieldSwitchProps = FieldProps & OtherProps;

export const FieldSwitch = ({
  field, // { name, value, onChange, onBlur }
  form: { setFieldValue },
  label,
  onClick,
  id
}: FieldSwitchProps) => {
  const fieldClasses = cx(formGroupStyles["form-group"]);

  return (
    <div className={fieldClasses}>
      <label htmlFor={field.name}>{label}</label>
      <PfSwitchButton
        id="pfSwitch"
        isOn={field.value}
        onClick={() => {
          setFieldValue(field.name, !field.value);
          onClick();
        }}
        onKeydown={() => {
          setFieldValue(field.name, !field.value);
        }}
      />
    </div>
  );
};
